import { AccountModel } from "@verivest/shared-components/src/api/models";
import { validateAddressReqAttr } from "./validateAddressReqAttr";
import { validateAllAttributesExistInData } from "./validateAllAttributesExistInData";
import { validateIndividualReqAttr } from "./validateIndividualReqAttr";

const validateEntityAndTrustCommonReqAttr = (
  entityOrTrust: AccountModel | null | undefined,
) => {
  if (!entityOrTrust) {
    return false;
  }

  const entityAndTrustCommonReqAttr: Array<keyof AccountModel> = [
    "name",
    "entityRegisteredType",
    "entityRegisteredDate",
    "taxIdNumber",
    "email",
    // "phone1Code",
    // "phone1",
    // "email1",
    // "signerTitle",
  ];

  if (entityOrTrust.entityRegisteredType === "U.S. Registered") {
    entityAndTrustCommonReqAttr.push("entityRegisteredState");
  } else {
    entityAndTrustCommonReqAttr.push("entityRegisteredCountry");
  }

  const areCommonAttributesValid = validateAllAttributesExistInData(
    entityAndTrustCommonReqAttr,
    entityOrTrust,
  );

  const isPrimaryAddressValid = validateAddressReqAttr(
    entityOrTrust.primaryAddress,
  );

  let isMailingAddressValid = true;
  if (entityOrTrust.mailingAddress) {
    isMailingAddressValid = validateAddressReqAttr(
      entityOrTrust.mailingAddress,
    );
  }

  let isSignerValid = false;
  if (entityOrTrust.signers?.length && entityOrTrust.signers.length > 0) {
    isSignerValid = entityOrTrust.signers.every((signer) => {
      return validateIndividualReqAttr(signer);
    });
  }

  return (
    areCommonAttributesValid &&
    isPrimaryAddressValid &&
    isMailingAddressValid &&
    isSignerValid
  );
};

export const validateEntityReqAttr = (
  entity: AccountModel | null | undefined,
) => {
  const areCommonAttributesValid = validateEntityAndTrustCommonReqAttr(entity);

  return areCommonAttributesValid;
};

export const validateTrustReqAttr = (
  trust: AccountModel | null | undefined,
) => {
  const areCommonAttributesValid = validateEntityAndTrustCommonReqAttr(trust);

  return areCommonAttributesValid;
};
